<template>
  <b-sidebar
    id="materialvariant-tracking-modal"
    header-class="headerModalToggle"
    :title="$t('MaterialVariantHistoryTrack')"
    right
    shadow
    width="60%"
    no-close-on-esc
    @hidden="onCancelToggle"
  >
    <template #title>
      <strong style="color: #101828;">{{ `${$t('MaterialVariantHistoryTrack')} ` + materialNameAddSub + ',' + ' Color: ' + colorNameAddSub }}</strong>
    </template>
    <template
      v-slot:header-close
    >

      <button
        style="color: #98A2B3;padding-left: 0px; padding-right: 0px;;height: 60px;"
        class="fa fa-close"
        @click="onCancelToggle"
      />
    </template>
    <LoadingWrapperSpinner
    request-id="materialVariantHistoryTrackPagination"
    style="padding: 10px;">
      <!-- <h4
        style="color: #262E6C; margin-top: 20px; font-weight: 400;"
      > {{ $t('MaterialVariantHistoryTrack') }}</h4> -->
      <div style="display: flex; margin-bottom: 1%">
        <b-form-group
          id="input-group-8"
          :label="$t('EditY')"
          style="width:25%;  margin-left: 0px; margin-right: 6px;"
          label-for="input-25"
        >
          <vue-select
            id="input-5"
            v-model="year"
            required
            :options="yearsArrays"
            :placeholder="$t('Select')"
            :clearable="false"
            aria-describedby="input-1-live-feedback"
          />
        </b-form-group>
        <b-form-group
          id="input-group-8"
          :label="$t('Month')"
          style="width:25%"
          label-for="input-25"
        >
          <vue-select
            id="input-5"
            v-model="month"
            :reduce="(e) => e.value"
            required
            :options="months"
            label="name"
            :placeholder="$t('Select')"
            aria-describedby="input-1-live-feedback"
          />
        </b-form-group>
        <div style="display: flex; align-items: end;">
          <button
            style="border: 0; width: 48px; height: 36px; background: #FF274F; border-radius: 5px; margin: 0px 10px"
            @click="downloadPDF"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="white"
              class="bi bi-file-earmark-pdf"
              viewBox="0 0 16 16"
            >
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
              <path d="M4.603 14.087a.81.81 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.68 7.68 0 0 1 1.482-.645 19.697 19.697 0 0 0 1.062-2.227 7.269 7.269 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a10.954 10.954 0 0 0 .98 1.686 5.753 5.753 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.856.856 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.712 5.712 0 0 1-.911-.95 11.651 11.651 0 0 0-1.997.406 11.307 11.307 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.793.793 0 0 1-.58.029zm1.379-1.901c-.166.076-.32.156-.459.238-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361.01.022.02.036.026.044a.266.266 0 0 0 .035-.012c.137-.056.355-.235.635-.572a8.18 8.18 0 0 0 .45-.606zm1.64-1.33a12.71 12.71 0 0 1 1.01-.193 11.744 11.744 0 0 1-.51-.858 20.801 20.801 0 0 1-.5 1.05zm2.446.45c.15.163.296.3.435.41.24.19.407.253.498.256a.107.107 0 0 0 .07-.015.307.307 0 0 0 .094-.125.436.436 0 0 0 .059-.2.095.095 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a3.876 3.876 0 0 0-.612-.053zM8.078 7.8a6.7 6.7 0 0 0 .2-.828c.031-.188.043-.343.038-.465a.613.613 0 0 0-.032-.198.517.517 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822.024.111.054.227.09.346z" />
            </svg>
          </button>
          <button
            style="    border: 0;
            width: 48px;
            height: 37px; background: #FF274F; border-radius: 5px;"
            @click="downloadEXCEL"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="white"
              class="bi bi-file-earmark-spreadsheet"
              viewBox="0 0 16 16"
            >
              <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V9H3V2a1 1 0 0 1 1-1h5.5v2zM3 12v-2h2v2H3zm0 1h2v2H4a1 1 0 0 1-1-1v-1zm3 2v-2h3v2H6zm4 0v-2h3v1a1 1 0 0 1-1 1h-2zm3-3h-3v-2h3v2zm-7 0v-2h3v2H6z" />
            </svg>
          </button>
        </div>
      </div>
      <table class="team_table">
        <thead>
          <tr style="text-align: left !important;">
            <th>
              {{ $t('Balance') }}
            </th>
            <th>
              {{ $t('AddedStock') }}
            </th>
            <th>
              {{ $t('SubstractedStock') }}
            </th>
            <th>
              {{ $t("Notes") }}
            </th>
            <th>
              {{ $t('TotalPrice') }}
            </th>
            <th>
              {{ $t('PricePerUnit') }}
            </th>
            <th>
              {{ $t("ExecutorName") }}
            </th>
            <th>
              {{ $t("Created") }}
            </th>
          </tr>
        </thead>
        <tr
          v-for="variant in getMaterialVariantHistory"
          :key="variant.materialVariantId"
          style="border-bottom: 1px solid #dcdfe6; color: #606266;"
        >
          <td>
            {{ variant.balanceStock }}
          </td>
          <td>
            {{ variant.newStockDeliver }}
          </td>
          <td>
            {{ variant.substractStock }}
          </td>
          <td>
            {{ variant.notes }}
          </td>
          <td
            v-if="variant.totalPrice == null"
          >
            {{ variant.totalPrice }}
          </td>
          <td
            v-else
          >
            {{ parseFloat(variant.totalPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}€
          </td>
          <td>
            {{
              variant.totalPrice > 0 && variant.newStockDeliver > 0
                ? (variant.totalPrice / variant.newStockDeliver).toFixed(2)
                : 0
            }}€
          </td>
          <td>
            {{ variant.fullName }}
          </td>
          <td>
            {{ createdDateModified(variant.created) }}
          </td>
        </tr>
        <tr v-if="getMaterialVariantHistory.length === 0">
          <td
            colspan="9"
          >
            {{ $t("NoHistoryMaterialVariantWasFound") }}!
          </td>
        </tr>
      </table>
      <div>
        <b-pagination
          v-if="getMaterialVariantHistoryTotalItems > 20"
          v-model="pageHistory"
          :total-rows="getMaterialVariantHistoryTotalItems"
          :per-page="pageSizeHistory"
          first-number
          last-number
          size="md"
          align="fill"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-1"
        >
          <template #prev-text>
            <span>{{ $t("Previous") }}</span>
          </template>
          <template #next-text>
            <span>{{ $t("Next") }}</span>
          </template>
        </b-pagination>
      </div>
    </LoadingWrapperSpinner>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['colorNameAddSub', 'materialNameAddSub', 'selectedMaterialVariantId'],
  data() {
    return {
      pageHistory: 1,
      pageSizeHistory: 5,
      year: moment().year(),
      month: moment().month() + 1,
      months: [
        {
          value: 1,
          name: this.$t('January'),
        },
        {
          value: 2,
          name: this.$t('February'),
        },
        {
          value: 3,
          name: this.$t('March'),
        },
        {
          value: 4,
          name: this.$t('April'),
        },
        {
          value: 5,
          name: this.$t('May'),
        },
        {
          value: 6,
          name: this.$t('June'),
        },
        {
          value: 7,
          name: this.$t('July'),
        },
        {
          value: 8,
          name: this.$t('August'),
        },
        {
          value: 9,
          name: this.$t('September'),
        },
        {
          value: 10,
          name: this.$t('October'),
        },
        {
          value: 11,
          name: this.$t('November'),
        },
        {
          value: 12,
          name: this.$t('December'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['getMaterialVariantHistoryTotalItems',
      'getMaterialVariantHistoryPDF',
      'getMaterialVariantHistoryTotalItems',
      'getMaterialVariantHistory',
      'productInStock_trackAndTrace',
      'getTotalPagesForMVM',
      'getProductInStockTrackAndTrace',
      'getFilteredOrdersbyON',
      'getCurrentPageForOrderTrackItems',
      'getTotalItemsForOrderTrackItems',
      'getLoggedInUser',
    ]),
    yearsArrays() {
      const result = [];
      const baseYear = this.year || moment().year();

      for (let i = -3; i < 4; i++) {
        result.push(baseYear + i);
      }

      return result;
    },
  },
  watch: {
    pageHistory(value) {
      this.materialVariantHistoryTrackPagination({
        materialVariantId: this.selectedMaterialVariantId,
        pageNumber: value,
        pageSize: this.pageSizeHistory,
        year: this.year,
        month: this.month,
      })
    },
    month(value) {
      this.materialVariantHistoryTrackPagination({
        materialVariantId: this.selectedMaterialVariantId,
        pageNumber: this.pageHistory,
        pageSize: this.pageSizeHistory,
        year: this.year,
        month: value,
      })
    },
    year(value) {
      this.materialVariantHistoryTrackPagination({
        materialVariantId: this.selectedMaterialVariantId,
        pageNumber: this.pageHistory,
        pageSize: this.pageSizeHistory,
        year: value,
        month: this.month,
      })
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions(['getOrdersOverview',
      'searchByOrderNumber',
      'fshij',
      'fshijCN',
      'changeLoadingtoTrue',
      'loadOrderTrackByOnAndAn',
      'materialVariantHistoryTrackPagination',
      'materialVariantHistoryTrackPaginationPDF',
    ]),
    onCancelToggle() {
      this.resetData();
      this.$emit('onCancelToggle');
    },
    resetData() {
      this.getMaterialVariantHistory = [];
      this.getMaterialVariantHistoryTotalItems = 0;
    },
    numbersWithcomma(value) {
      const options = {
        style: 'decimal', // Other options: 'currency', 'percent', etc.
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      };
      return value.toLocaleString('en-US', options);
    },
    createdDateModified(xdate) {
      return moment(xdate).format('DD/MM/YYYY - HH:mm');
    },
    generateExcel(tableContent) {
      const { headers, body } = tableContent;
      const sheetData = [headers, ...body];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      const excelData = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

      return excelData;
    },
    downloadEXCEL() {
      // axios
      //   .get(`https://logistictourmanagement.digitwebsite.ch/api/v1/workingHoursForStore?storeGLN=${this.storeGLN}&startDate=${this.startDate}&endDate=${this.endDate}`)
      this.materialVariantHistoryTrackPaginationPDF({
        materialVariantId: this.selectedMaterialVariantId,
        pageNumber: this.pageHistory,
        pageSize: this.pageSizeHistory,
        year: this.year,
        month: this.month,
      }).then(() => {
        // const data = response.data;
        // const items = data.items;

        const tableContent = this.generateTableContent(this.getMaterialVariantHistoryPDF);

        const totalPages = this.getMaterialVariantHistoryTotalPages;
        const additionalPromises = [];
        for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
          additionalPromises.push(this.downloadPage(pageNumber));
        }

        Promise.all(additionalPromises).then((additionalTableContents) => {
          additionalTableContents.forEach((additionalTableContent) => {
            tableContent.body = tableContent.body.concat(additionalTableContent.body);
          });

          const excelData = this.generateExcel(tableContent);


          // Get the current date and time
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');

          // Format the date and time
          const formattedDateTime = `${day}/${month}/${year}_${hours}${minutes}`;

          // Create the dynamic file name
          const fileName = `${this.materialNameAddSub}_${formattedDateTime}.xlsx`;

          FileSaver.saveAs(excelData, fileName);
        });
      })
        .catch((error) => {
          console.error('Error downloading the data:', error);
        });
    },
    downloadPDF() {
      // this.changeLoadingtoTrue(false);

      // axios
      //   .get('https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=1&PageSize=12')
      this.materialVariantHistoryTrackPaginationPDF({
        materialVariantId: this.selectedMaterialVariantId,
        pageNumber: this.pageHistory,
        pageSize: this.pageSizeHistory,
        year: this.year,
        month: this.month,
      })
        .then(() => {
          // const data = response.data;
          // const items = data.items;

          const tableContent = this.generateTableContent(this.getMaterialVariantHistoryPDF);

          const totalPages = this.getMaterialVariantHistoryTotalPages;
          const additionalPromises = [];
          for (let pageNumber = 2; pageNumber <= totalPages; pageNumber++) {
            additionalPromises.push(this.downloadPage(pageNumber));
          }

          Promise.all(additionalPromises).then((additionalTableContents) => {
            additionalTableContents.forEach((additionalTableContent) => {
              tableContent.body.push(...additionalTableContent.body);
            });

            const footerIcon = 'data:image/png;base64,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'

            const pdfDocument = this.generatePDF(tableContent, footerIcon);

            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');

            // Format the date and time
            const formattedDateTime = `${day}/${month}/${year}_${hours}${minutes}`;

            const fileName = `${this.materialNameAddSub}_${formattedDateTime}.pdf`;
            pdfDocument.save(fileName, pdfDocument);
          });
          // this.changeLoadingtoTrue(true);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    downloadPage(pageNumber) {
      // axios
      //   .get(
      //     `https://logisticstoredata.digitwebsite.ch/api/v1/extendedStoresByPagination?PageNumber=${pageNumber}&PageSize=12`,
      //   )
      // this.changeLoadingtoTrue(false);

      return this.materialVariantHistoryTrackPaginationPDF({
        materialVariantId: null,
        year: null,
        month: null,
        pageNumber,
        pageSize: this.pageSizeHistory,
      })

        .then(() => {
          // const data = response.data;
          // const items = data.items;
          // this.changeLoadingtoTrue(true);

          return this.generateTableContent(this.getMaterialVariantHistoryPDF);
        })
        .catch((error) => {
          console.error('Error downloading the data:', error);
          // this.changeLoadingtoTrue(false);
        });
    },
    generateTableContent(items) {
      // const headers = [`${this.$t('FilialeName')}`, 'GLN', 'Email', 'Phone', 'Street', 'City', 'Country', 'Trucks', 'Manager', 'TeamLeader', 'Co-TeamLeader'];
      const headers = [`${this.$t('Balance')}`, `${this.$t('AddedStock')}`,
        `${this.$t('SubstractedStock')}`, `${this.$t('Notes')}`, `${this.$t('PriceMeter/Part')}`,
        `${this.$t('ExecutorName')}`, `${this.$t('Created')}`];
      console.log(items)
      const body = items.map((item) => {
        return [
          item.balanceStock,
          item.newStockDeliver,
          item.substractStock,
          item.notes,
          item.totalPrice,
          item.fullName,
          this.dateFormat(item.created),
        ]
      });

      return { headers, body };
    },
    generatePDF(tableContent, footerIcon) {
      const { headers, body } = tableContent;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF();

      const iconWidth = 30; // Adjust the width of the icon as needed
      const iconHeight = 10; // Adjust the height of the icon as needed
      const iconY = 10; // Adjust the vertical position of the icon (top)

      // Draw a blue background rectangle that spans the entire width of the paper
      const blueBackgroundX = 0;
      const blueBackgroundWidth = doc.internal.pageSize.getWidth();
      const blueBackgroundHeight = 25; // Adjust the height as needed
      doc.setFillColor(36, 47, 110); // Blue color
      doc.rect(blueBackgroundX, 0, blueBackgroundWidth, blueBackgroundHeight, 'F');

      // Add the logo image on top of the blue background on the top left
      const iconX = 15; // Adjust the horizontal position of the icon (left)
      doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);



      const staticContent = () => {
        // Draw blue background for the footer
        const blueBackgroundFooterX = 0;
        const blueBackgroundFooterY = doc.internal.pageSize.getHeight() - 15;
        const blueBackgroundFooterWidth = doc.internal.pageSize.getWidth();
        const blueBackgroundFooterHeight = 25;
        doc.setFillColor(36, 47, 110); // Blue color (RGB values)
        doc.rect(blueBackgroundFooterX, blueBackgroundFooterY, blueBackgroundFooterWidth, blueBackgroundFooterHeight, 'F');

        // Add URL
        const url = 'www.digitbusiness.ch';
        const urlX = 30;
        const urlY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(url, urlX, urlY, { align: 'center' });

        // Add address
        const address = 'Steinstrasse 56, 8003 Zürich, Switzerland';
        const addressX = 165;
        const addressY = doc.internal.pageSize.getHeight() - 7;
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(address, addressX, addressY, { align: 'center' });
      };

      // Add the logo to the top left corner of the first page
      // const iconWidth = 30; // Adjust the width of the icon as needed
      // const iconHeight = 10; // Adjust the height of the icon as needed
      // const iconX = 15; // Adjust the horizontal position of the icon (left)
      // const iconY = 5; // Adjust the vertical position of the icon (top)
      // doc.addImage(footerIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

      const currentTime = moment().format('DD-MM-YYYY, HH:mm:ss');
      const timeX = doc.internal.pageSize.getWidth() / (10 / 9);
      const timeY = 10;
      doc.setFontSize(10);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(currentTime, timeX, timeY, { align: 'right' });

      // Add the title
      const title = `${this.materialNameAddSub}, Color: ${this.colorNameAddSub}`;
      const titleX = doc.internal.pageSize.getWidth() / 2;
      const titleY = 20; // Adjust the vertical position of the title
      doc.setFontSize(18);
      doc.setTextColor(255, 255, 255); // Black color
      doc.text(title, titleX, titleY, { align: 'center' });

      // Add the author
      const authorX = 15;
      const authorY = 30; // Adjust the vertical position of the author
      const author = `${this.getLoggedInUser.firstName} ${this.getLoggedInUser.lastName}`;
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0); // Black color
      doc.text(`${this.$t('Author')}: ${author}`, authorX, authorY);

      // Add the table
      const tableOptions = {
        startY: authorY + 5, // Adjust the vertical position of the table
        time: moment().format('DD-MM-YYYY'),
        head: [headers],
        body,
        headStyles: {
          fillColor: [36, 47, 110], // Set the background color for the header
          textColor: [255, 255, 255], // Set the text color for the header
        },
        afterPageContent: staticContent,
      };
      doc.autoTable(tableOptions);
      return doc;
    },

    dateFormat(value) {
      return moment(value).format('DD-MM-YYYY, HH:mm')
    },
  },
};
</script>

<style scoped>
.team_table td {
  width: 7%;
  padding: 16px 10px !important;
}
</style>
